                                                                                                


          
  
    






// globals ***

// determine if search page is accessed 
var isSearchPage = false;
var thisCollectionPath = window.location.pathname; 
if (thisCollectionPath === "/search") { isSearchPage = true; }




// tidio display helper *** 
function tidioChatDisplay(state) {
    let tidio = window.tidioChatApi;
    if (!tidio) return;
    if (state === "hide") {
        tidio.hide();
    } 
    else if (state === "show") {
        tidio.show();
    }
}




// open filter modal *** 
$("#ChangeCollection").click(function() { 
    tidioChatDisplay("hide");
    $("#CollectionFilterModal").addClass("active"); 
});






// close filter modal ***
$("#CollectionFilterModalHeader h2").click(function() {
    $("#CollectionFilterModal").removeClass("active"); 
    $(".collection-nav-dd-outer.active").removeClass("active"); 
    tidioChatDisplay("show");
});






// collection nav dds *** 
$(".collection-nav-dd-outer").click(function(e) {
    e.stopPropagation();
    if ($(this).hasClass("active")) {
        $(".collection-nav-dd-outer.active").removeClass("active"); 
        $(".collection-nav-dd-inner.active").removeClass("active");
    }
    else {
        $(".collection-nav-dd-outer.active").removeClass("active");
        $(this).addClass("active");
        $(".collection-nav-dd-inner.active").removeClass("active");
        $(this).find(".collection-nav-dd-inner").addClass("active")
    }
});

 




// close an open collection nav dd or filter modal on document press ***  
$(document).click(function (e) {
    if ($(".collection-nav-dd-outer").hasClass("active") && !$("#CollectionFilterModal").hasClass("active")) {
        if (!$(e.target).closest(".collection-nav-dd-outer").length) {
            $(".collection-nav-dd-outer.active").removeClass("active");
            $(".collection-nav-dd-inner.active").removeClass("active");
        }
    } 
    if ($("#CollectionFilterModal").hasClass("active")) {
        if (!$(e.target).closest("#CollectionFilterModalInner").length) {
            $("#CollectionFilterModal").removeClass("active"); 
            $(".collection-nav-dd-outer.active").removeClass("active"); 
            tidioChatDisplay("show");
        } 
    } 
});






// apply active classes to active filters on load *** 
var sortByFound = false;
var activeFilterUrl = new URL(window.location.href);
activeFilterUrl.searchParams.forEach((value, key) => { 
    let el = $("[data-filter-value='" + value + "'][data-filter-param='" + key + "']");
    el.addClass("active"); 
    if (key === "sort_by") {
        $("#SortCollection h2 .title").text(el.text());
        sortByFound = true; 
    } 
}); 
if (!sortByFound) {
    $("#SortCollection h2 .title").text("Default");
    $("[data-filter-value='default'][data-filter-param='sort_by']").addClass("active");
}






// defaut to best selling if raw collection is accessed ***
/*
if (activeFilterUrl.searchParams.size === 0) {
    $(".dds-collection-filter[data-filter-value='best-selling']").addClass("active");
    $("#SortCollection h2 .title").text("Best Selling"); 
}
*/        






// if filter count is 0, disable option ***
$(".dds-collection-filter").each(function(i, obj) {
    let filterParam = $(obj).data("filter-param"); 
    if (!(filterParam === "sort_by") && !(filterParam === "filter.v.price.gte") && !(filterParam === "filter.v.price.lte")) {
        if (Number($(obj).find("span.count").text().replace("(","").replace(")","")) === 0) {
            $(obj).css({"text-decoration":"line-through","opacity":"0.3","pointer-events":"none"});
        }
    }
});


   



// toggle active class for filter btns *** 
$(".dds-collection-filter").click(function(e) {
    let filterParam = $(this).data("filter-param"); 
    if (!(filterParam === "filter.v.price.gte") && !(filterParam === "filter.v.price.lte")) {
        if (filterParam === "sort_by") {
            if (!$(this).hasClass("active")) {
                $("#SortCollectionDD a.active").removeClass("active");
                $(this).addClass("active");
            }
        }
        else {
            if ($(this).hasClass("active")) {
                $(this).removeClass("active"); 
            }
            else { 
                if (filterParam === "filter.v.availability") {
                    $("[data-filter-param='filter.v.availability'].active").removeClass("active");
                }
                $(this).addClass("active"); 
            }
        }
    }
});






// calculate max price *** 
let maxFilterPrice = 9999;   
let minFilterPrice = 0;
let urlMaxFilterPrice = 9999;
let urlMinFilterPrice = 0;
let activePriceFilterUrl = new URL(window.location.href);
activePriceFilterUrl.searchParams.forEach((value, key) => { 
    if (key === "filter.v.price.lte") {
        urlMaxFilterPrice = value;
    } 
    if (key === "filter.v.price.gte") {
        urlMinFilterPrice = value;
    }
}); 






// remove variants outside of price range filter + other *** 
$("#CollectionProducts .dds-product").each(function(i, obj) {
    let priceEl = $(obj).find(".dds-prodprice");
    let price;
    if (priceEl.find("span").length > 0) {
        price = Number(priceEl.find(".dds-prodsaleprice").text().replace("$","").trim());
    }
    else {
        price = Number(priceEl.text().replace("$","").trim());
    }

    if (price < Number(urlMinFilterPrice) || price > Number(urlMaxFilterPrice)) {
        $(obj).remove();
    }

    // if (price > calculatedMax) { calculatedMax = price; }

}); 






// sort by price asc / desc helper (per variants) *** 

// determine if sort_by price filter exists
let sortByPriceFilterActive = new URL(window.location.href);
sortByPriceFilterActive.searchParams.forEach((value, key) => { 
    if (key === "sort_by" && value === "price-ascending") { sortProducts("asc"); } 
    if (key === "sort_by" && value === "price-descending") { sortProducts("desc"); }
}); 

// sort function 
function sortProducts(order) {
    
    let $container = $("#CollectionProducts");
    let products = $container.find(".dds-product").get();

    products.sort(function(a, b) {

        let priceA, priceB;
        let $a = $(a).find(".dds-prodprice");
        let $b = $(b).find(".dds-prodprice");

        priceA = $a.find("span").length > 0
            ? Number($a.find(".dds-prodsaleprice").text().replace("$","").trim())
            : Number($a.text().replace("$","").trim());

        priceB = $b.find("span").length > 0
            ? Number($b.find(".dds-prodsaleprice").text().replace("$","").trim())
            : Number($b.text().replace("$","").trim());

        if (order === "asc") { return priceA - priceB; } else { return priceB - priceA; }

    });

    $.each(products, function(_, prod) { $container.append(prod); });

}






// set total prod count (collection page only) *** 
if (!isSearchPage) { $("#CollectionNavProdTotal").text($("#CollectionProducts .dds-product").length); } 






// add in-view class to first row of grid *** 
let thisCollectionGrid = $("#CollectionProducts");   
let thisCollectionGridCols = window.getComputedStyle(thisCollectionGrid[0]).gridTemplateColumns.split(' ').length;
thisCollectionGrid.children().slice(0, thisCollectionGridCols).addClass('in-view');






// price filter functions *** 

// init inputs 
let minFilterPriceInput = $("#price-min-input");
let maxFilterPriceInput = $("#price-max-input"); 

// init input attributes 
minFilterPriceInput.attr({ min: 0, max: maxFilterPrice, value: urlMinFilterPrice, 'data-filter-value': urlMinFilterPrice }); 
maxFilterPriceInput.attr({ min: 0, max: maxFilterPrice, value: urlMaxFilterPrice, 'data-filter-value': urlMaxFilterPrice });

// clamp function 
function clampFilterPrice(n, lo, hi) {
  const x = parseFloat(n);
  if (isNaN(x)) return NaN;
  return Math.min(Math.max(x, lo), hi);
}

// handle min input 
function handleMinFilterInput() {
  let minVal = clampFilterPrice(minFilterPriceInput.val(), 0, maxFilterPrice);
  if (isNaN(minVal)) minVal = 0;
  let maxVal = clampFilterPrice(maxFilterPriceInput.val(), minVal, maxFilterPrice);
  if (isNaN(maxVal)) maxVal = minVal;
  minFilterPriceInput.val(minVal);
  maxFilterPriceInput.val(maxVal);
  minFilterPriceInput.attr('data-filter-value', minVal);
  maxFilterPriceInput.attr('data-filter-value', maxVal);
}

// handle max input 
function handleMaxFilterInput() {
  let minVal = clampFilterPrice(minFilterPriceInput.val(), 0, maxFilterPrice);
  if (isNaN(minVal)) minVal = 0;
  let maxVal = clampFilterPrice(maxFilterPriceInput.val(), minVal, maxFilterPrice);
  if (isNaN(maxVal)) maxVal = maxFilterPrice;
  minFilterPriceInput.val(minVal);
  maxFilterPriceInput.val(maxVal);
  minFilterPriceInput.attr('data-filter-value', minVal);
  maxFilterPriceInput.attr('data-filter-value', maxVal);
}

// run function on blur 
minFilterPriceInput.on("blur", handleMinFilterInput);
maxFilterPriceInput.on("blur", handleMaxFilterInput);






// clear filter btn ***   
$("#CollectionFilterModal .cfmc-clear-btn").click(function() {
    if ($(this).hasClass("pricefilter")) {
        $("#CollectionFilterModal #price-min-input").val(0);
        $("#CollectionFilterModal #price-min-input").attr("data-filter-value", 0); 
        $("#CollectionFilterModal #price-max-input").val(9999); 
        $("#CollectionFilterModal #price-max-input").attr("data-filter-value", 9999); 
    }
    else {
        $("#CollectionFilterModal .cfmc-dd.cfmcdd" + $(this).attr("data-num")).find(".dds-collection-filter").removeClass("active");  
    }
});       






// handle page reload per updated filters *** 
$("#CollectionFilterModalFooter h1, #SortCollectionDD a").click(function(e) {

    // prevent default 
    e.preventDefault();

    // if filter modal 'apply changes' press, timeout 
    let filterModalTimeout = 0;
    if ($(this).parent().attr("id") === "CollectionFilterModalFooter") {
        filterModalTimeout = 400;
        $("#CollectionFilterModalHeader h2").click(); 
    }

    // construct new url 
    setTimeout(function() {

        // init url 
        let url = new URL(window.location.href);

        // clear out filter params before rebuilding
        url.searchParams.delete("filter.p.tag");
        url.searchParams.delete("filter.p.vendor");
        url.searchParams.delete("filter.v.availability");
        url.searchParams.delete("sort_by");
        url.searchParams.delete("page");

        // loop through all active selections  
        $(".dds-collection-filter.active").each(function() {
            let val = $(this).data("filter-value"); 
            let param  = $(this).data("filter-param");
            let method = $(this).data("filter-method"); 
            if (!(method === "remove")) {
                if (method === "set") {
                    url.searchParams.set(param, val);
                } 
                else {
                    url.searchParams.append(param, val);
                }
            }  
        });

        // set page param to 1 
        url.searchParams.set("page", "1"); 

        // Shopify normalization (spaces → '+') 
        window.location.href = url.toString().replace(/%20/g, "+").replace(/%2B/g, "+");

    }, filterModalTimeout);

});











